
export default function ComparisonTableSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Cash Sale vs. Traditional Listing: The Real Comparison
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Here's an honest breakdown of what you can expect when selling land through traditional methods versus selling for cash to TRex RE LLC.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full bg-white shadow-lg rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-gray-900 text-white">
                <th className="px-6 py-4 text-left text-lg font-bold">Factor</th>
                <th className="px-6 py-4 text-left text-lg font-bold bg-teal-600">Cash Sale (TRex RE LLC)</th>
                <th className="px-6 py-4 text-left text-lg font-bold">Traditional Listing</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200">
                <td className="px-6 py-4 font-semibold text-gray-900">Time to Close</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>7-14 days (your choice)</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">6-12 months average (sometimes years)</td>
              </tr>
              <tr className="border-b border-gray-200 bg-gray-50">
                <td className="px-6 py-4 font-semibold text-gray-900">Realtor Commission</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>$0 - No commission</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">6-10% of sale price ($3,000-$5,000 on $50k land)</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="px-6 py-4 font-semibold text-gray-900">Closing Costs</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>$0 - We pay all costs</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">$1,500-$3,000 (title, escrow, transfer taxes)</td>
              </tr>
              <tr className="border-b border-gray-200 bg-gray-50">
                <td className="px-6 py-4 font-semibold text-gray-900">Property Condition</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>Sell 100% as-is</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">May need clearing, grading, or improvements</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="px-6 py-4 font-semibold text-gray-900">Inspections Required</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>None</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">Survey, environmental, perc tests ($2,000-$5,000)</td>
              </tr>
              <tr className="border-b border-gray-200 bg-gray-50">
                <td className="px-6 py-4 font-semibold text-gray-900">Showings & Open Houses</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>None required</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">Multiple showings, often with no offers</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="px-6 py-4 font-semibold text-gray-900">Financing Contingencies</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>None - guaranteed cash</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">High risk of deal falling through (30-40% failure rate)</td>
              </tr>
              <tr className="border-b border-gray-200 bg-gray-50">
                <td className="px-6 py-4 font-semibold text-gray-900">Ongoing Holding Costs</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>Minimal (7-14 days)</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">6-12 months of taxes, insurance, maintenance</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="px-6 py-4 font-semibold text-gray-900">Title Issues Handled</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>Yes - we handle complications</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">Seller must resolve before closing</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="px-6 py-4 font-semibold text-gray-900">Certainty of Sale</td>
                <td className="px-6 py-4 bg-teal-50">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>100% guaranteed</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700">Uncertain - many listings expire without selling</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-12 bg-gray-50 rounded-lg p-8">
          <h3 className="text-2xl font-bold mb-4 text-gray-900">Real Example: $50,000 Land Sale</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-xl font-bold mb-4 text-teal-600">Cash Sale to TRex RE LLC</h4>
              <div className="space-y-2 text-gray-700">
                <div className="flex justify-between">
                  <span>Sale Price:</span>
                  <strong>$50,000</strong>
                </div>
                <div className="flex justify-between">
                  <span>Realtor Commission:</span>
                  <strong>$0</strong>
                </div>
                <div className="flex justify-between">
                  <span>Closing Costs:</span>
                  <strong>$0</strong>
                </div>
                <div className="flex justify-between">
                  <span>Holding Costs (2 weeks):</span>
                  <strong>$50</strong>
                </div>
                <div className="flex justify-between border-t-2 border-teal-600 pt-2 mt-2">
                  <span className="font-bold">Net to Seller:</span>
                  <strong className="text-teal-600 text-xl">$49,950</strong>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-4 text-gray-900">Traditional Listing (8 months)</h4>
              <div className="space-y-2 text-gray-700">
                <div className="flex justify-between">
                  <span>Sale Price:</span>
                  <strong>$50,000</strong>
                </div>
                <div className="flex justify-between">
                  <span>Realtor Commission (6%):</span>
                  <strong>-$3,000</strong>
                </div>
                <div className="flex justify-between">
                  <span>Closing Costs:</span>
                  <strong>-$2,000</strong>
                </div>
                <div className="flex justify-between">
                  <span>Holding Costs (8 months):</span>
                  <strong>-$1,200</strong>
                </div>
                <div className="flex justify-between border-t-2 border-gray-900 pt-2 mt-2">
                  <span className="font-bold">Net to Seller:</span>
                  <strong className="text-gray-900 text-xl">$43,800</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 p-4 bg-teal-50 rounded-lg border-l-4 border-teal-600">
            <p className="text-gray-900 font-semibold">
              <i className="ri-lightbulb-fill text-teal-600 mr-2"></i>
              By selling for cash, you could net $6,150 more and close in 2 weeks instead of 8 months. That's the power of avoiding commissions, closing costs, and holding expenses.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
